import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";
import { adminMainUrl } from "../../../Config";
import {
  getAllLedgerAccountIdAndPartyName,
  getAllMasterBranchIdAndName,
  getAllMasterCurrencyIdAndName,
  getCurrency,
} from "../../../Redux/action/MasterAction";
import { ref } from "yup";
import { generateCode } from "../../../helper/autoGenId";
import axios from "axios";

const VoucherProcessingJournalVoucher = () => {
  const token = Cookies.get("token");
  let user_id = Cookies.get("flexichain_user_id");
  let currencyData = useSelector((state) =>
    state?.MasterReducer ? state?.MasterReducer?.currencyData : [],
  );

  const {
    MasterBranchName,
    MasterBranchNameError,
    loadingMasterBranchName,
    loadingMasterCashBookName,
    MasterCashBookName,
    MasterCashBookNameError,

    loadingLedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyNameError,

    loadingMasterCurrencyIdAndName,
    MasterCurrencyIdAndName,
    MasterCurrencyIdAndNameError,
  } = useSelector((state) => state?.MasterReducer);

  const testJournalFormData = [
    {
      journal_voucher_code: "JV-2026-00125",
      journal_voucher_branch: "Mumbai Head Office",
      journal_voucher_date: "2026-02-02",
      journal_voucher_currency: "INR",
      journal_voucher_exchange_rate: "1",

      journal_voucher_account_name: "ABC Suppliers Pvt Ltd",
      journal_voucher_amount: "25000",
      journal_voucher_debit_or_credit: "Debit", // or "Credit"

      journal_voucher_ref_no: "INV-45879",
      journal_voucher_ref_date: "2026-01-28",
      journal_voucher_ref_amount: "25000",

      journal_voucher_is_tds: "Yes", // "Yes" or "No"
      journal_voucher_is_gst: "Yes", // "Yes" or "No"

      journal_voucher_job_order_no: "JOB-9032",
      journal_voucher_cost_center: "Marketing Department",
      journal_voucher_address: "Andheri East, Mumbai, Maharashtra, India",
      journal_voucher_narration:
        "Payment recorded against supplier invoice INV-45879 for digital marketing services.",
    },
  ];

  const [journalFormData, setJournalFormData] = useState({
    journal_voucher_code: "",
    journal_voucher_branch: "",
    journal_voucher_date: "",
    journal_voucher_currency: "",
    journal_voucher_exchange_rate: "",
    journal_voucher_account_name: "",
    journal_voucher_amount: "",
    journal_voucher_debit_or_credit: "",

    journal_voucher_ref_type: "",
    journal_voucher_ref_no: "",
    journal_voucher_ref_date: "",
    journal_voucher_ref_amount: "",

    journal_voucher_is_tds: "",
    journal_voucher_is_gst: "",

    journal_voucher_job_order_no: "",
    journal_voucher_cost_center: "",
    journal_voucher_address: "",
    journal_voucher_narration: "",
  });

  const [spinnerLoader, setSpinnerLoader] = useState(false);
  // const handleAddShow = () => setAddShow(true);
  const [voucherData, setVoucerData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const dispatch = useDispatch();

  const nonNegativeFields = [
    "journal_voucher_exchange_rate",
    "journal_voucher_amount",
    "journal_voucher_ref_amount",
  ];

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    let finalValue = value;
    // If input type is number
    if (type === "number") {
      const numericValue = Number(value);

      // Block negative values for fixed fields
      if (nonNegativeFields.includes(name) && numericValue <= 0) {
        finalValue = ""; // or "" if you prefer empty
      } else {
        finalValue = numericValue;
      }
    }

    setJournalFormData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  const getAllVoucherData = async (page = 1) => {
    setSpinnerLoader(true);
    try {
      const data = await fetch(
        `${adminMainUrl}/api/account/journal-voucher?page=${page}`,
      );

      const res = await data.json();

      if (res.code == 200) {
        setVoucerData(res.data);
        const cPage = res?.pagination?.currentPage;
        const tPage = res?.pagination?.totalPages;
        setCurrentPage(cPage);
        setTotalPage(tPage);
      }
    } catch (error) {
      setSpinnerLoader(false);
      console.error("Network error:", error);
    } finally {
      setSpinnerLoader(false);
    }
  };

  const validateData = () => {
    if (!journalFormData.journal_voucher_date) {
      toast.error("Please select journal voucher date");
      return false;
    }
    if (!journalFormData.journal_voucher_exchange_rate) {
      toast.error("Please enter journal voucher exchange rate");
      return false;
    }
    if (!journalFormData.journal_voucher_amount) {
      toast.error("Please enter journal voucher amount");
      return false;
    }
    if (!journalFormData.journal_voucher_job_order_no) {
      toast.error("Please enter journal voucher job order no");
      return false;
    }
    if (!journalFormData.journal_voucher_ref_no) {
      toast.error("Please enter journal voucher ref no");
      return false;
    }
    if (!journalFormData.journal_voucher_ref_date) {
      toast.error("Please select journal voucher ref date");
      return false;
    }
    if (!journalFormData.journal_voucher_ref_amount) {
      toast.error("Please enter journal voucher ref amount");
      return false;
    }
    if (!journalFormData.journal_voucher_address) {
      toast.error("Please enter journal voucher address");
      return false;
    }
    if (!journalFormData.journal_voucher_narration) {
      toast.error("Please enter journal voucher narration");
      return false;
    }
    return true;
  };

  const useThrottle = (callback, delay) => {
    const lastRun = React.useRef(0);
    return () => {
      const now = Date.now();
      if (now - lastRun.current >= delay) {
        lastRun.current = now;
        callback();
      }
    };
  };

  const throttledSubmit = useThrottle(() => {
    submitJournalForm();
  }, 2000); // allow once every 2 seconds

  const submitJournalForm = async () => {
    if (!validateData()) {
      return;
    }
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/journal-voucher`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify(journalFormData),
        },
      );
      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg);
        clearJournalForm();
        refresh();
      } else {
        toast.error(data?.msg);
        // Handle errors from the server
        console.error("Error creating master currency:", data.message);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const clearJournalForm = () => {
    setJournalFormData({
      journal_voucher_code: "",
      journal_voucher_branch: "",
      journal_voucher_date: "",
      journal_voucher_currency: "",
      journal_voucher_exchange_rate: "",
      journal_voucher_account_name: "",
      journal_voucher_amount: "",
      journal_voucher_debit_or_credit: "",

      journal_voucher_ref_type: "",
      journal_voucher_ref_no: "",
      journal_voucher_ref_date: "",
      journal_voucher_ref_amount: "",

      journal_voucher_is_tds: "",
      journal_voucher_is_gst: "",

      journal_voucher_job_order_no: "",
      journal_voucher_cost_center: "",
      journal_voucher_address: "",
      journal_voucher_narration: "",
    });
  };

  const refresh = () => {
    if (token && user_id) {
     getAllVoucherData()
    }
  };



  const columns = [
    {
      title: "Voucher Code",
      dataIndex: "voucher_code",
      key: "voucher_code",
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Exchange Rate",
      dataIndex: "exchange_rate",
      key: "exchange_rate",
    },
    {
      title: "Account Name",
      dataIndex: "account_name",
      key: "account_name",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Ref No",
      dataIndex: "ref_no",
      key: "ref_no",
    },
    {
      title: "Ref Date",
      dataIndex: "ref_date",
      key: "ref_date",
    },
    {
      title: "Ref Amount",
      dataIndex: "ref_amount",
      key: "ref_amount",
    },
    {
      title: "TDS",
      dataIndex: "tds",
      key: "tds",
    },
    {
      title: "GST",
      dataIndex: "gst",
      key: "gst",
    },
    {
      title: "Debit/Credit",
      dataIndex: "credi_or_debit",
      key: "credi_or_debit",
    },
    {
      title: "Job Order No",
      dataIndex: "job_order_no",
      key: "job_order_no",
    },
    {
      title: "Cost Center",
      dataIndex: "cost_center",
      key: "cost_center",
    },
    // {
    //     title: "Address",
    //     dataIndex: "address",
    //     key: "address",
    // },
    // {
    //     title: "Narration",
    //     dataIndex: "narration",
    //     key: "narration",
    // }

    // { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = voucherData?.map((value, i) => ({
    key: i, // Add a unique key for each row
    SNo: i + 1, // Changed to camelCase
    voucher_code: value?.journal_voucher_code,
    branch: value?.journal_voucher_branch,
    date: value?.journal_voucher_date.split("T")[0],
    currency: value?.journal_voucher_currency,
    exchange_rate: value?.journal_voucher_exchange_rate,
    account_name: value?.journal_voucher_account_name,
    amount: value?.journal_voucher_amount,

    ref_no: value?.journal_voucher_ref_no,
    ref_date: value?.journal_voucher_ref_date.split("T")[0],
    ref_amount: value?.journal_voucher_ref_amount,

    tds: value?.journal_voucher_is_tds == 1 ? "YES" : "NO",
    gst: value?.journal_voucher_is_gst == 1 ? "YES" : "NO",

    credi_or_debit: value?.journal_voucher_debit_or_credit,
    job_order_no: value?.journal_voucher_job_order_no,
    cost_center: value?.journal_voucher_cost_center,

    // address: value?.journal_voucher_address,
    // narration: value?.journal_voucher_narration,

    // action: (
    //   <div className="dropdown table-action">
    //     <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //       <i className="fa fa-ellipsis-v"></i>
    //     </Link>
    //     <div className="dropdown-menu dropdown-menu-right">
    //       <div
    //         className=" cursor-pointer"
    //         onClick={() => {
    //           //  handleEditShow(value?.id);
    //           setMasterID(value?.id);
    //           setMasterName(value?.name);
    //         }}
    //       >
    //         <i className="ti ti-edit text-blue"></i> Edit
    //       </div>
    //     </div>
    //   </div>
    // ),
  }));

  useEffect(() => {
    const currentCurrency = MasterCurrencyIdAndName.find(
      (item) => item.currency_name==journalFormData.journal_voucher_currency
    );

    setJournalFormData((pre) => ({
      ...pre,
      journal_voucher_exchange_rate:currentCurrency?.exchange_rate || 0
    }));
  }, [journalFormData.journal_voucher_currency]);

  useEffect(() => {
    if (token && user_id) {
      let invoice_id = generateCode();
      if (invoice_id) {
        setJournalFormData((pre) => ({
          ...pre,
          ["journal_voucher_code"]: invoice_id,
        }));
      }

      getAllVoucherData();
      dispatch(getAllMasterBranchIdAndName(token, user_id));
      dispatch(getAllLedgerAccountIdAndPartyName(token, user_id));
      dispatch(getAllMasterCurrencyIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>
      <div>
        <h5 className="fw-semibold mb-3">Journal Voucher Form</h5>

        <div className="row">
          {/* journal_voucher_code */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Voucher No <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="journal_voucher_code"
              className="form-control bg-light"
              placeholder="Auto-generated"
              disabled
              value={journalFormData.journal_voucher_code}
            />
          </div>

          {/* journal_voucher_branch */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Branch <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_branch}
              name="journal_voucher_branch"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Branch </option>
              {MasterBranchName?.map((item, i) => (
                <option key={i} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* journal_voucher_date*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Date<span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="journal_voucher_date"
              className="form-control bg-light"
              placeholder="Date"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_date}
            />
          </div>

          {/* journal_voucher_currency */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Currency <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_currency}
              name="journal_voucher_currency"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Currency </option>
              {MasterCurrencyIdAndName?.map((item, i) => (
                <option key={i} value={item.currency_name}>
                  {item.currency_name}
                </option>
              ))}
            </select>
          </div>

          {/* journal_voucher_exchange_rate*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Exchange Rate <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="journal_voucher_exchange_rate"
              className="form-control bg-light"
              placeholder="Enter Exchange Rate"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_exchange_rate}
            />
          </div>

          {/* journal_voucher_account_name */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Account Name <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_account_name}
              name="journal_voucher_account_name"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Account Name </option>
              {LedgerAccountIdAndPartyName?.map((item, i) => (
                <option key={i} value={item.ledger_party_name}>
                  {item.ledger_party_name}
                </option>
              ))}
            </select>
          </div>

          {/* journal_voucher_amount*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Amount <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="journal_voucher_amount"
              className="form-control bg-light"
              placeholder="Enter Amount"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_amount}
            />
          </div>

          {/* journal_voucher_job_order_no*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Job Order No <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="journal_voucher_job_order_no"
              className="form-control bg-light"
              placeholder="Enter Job Order No"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_job_order_no}
            />
          </div>

          {/* journal_voucher_debit_or_credit */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Dr/Cr <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_debit_or_credit}
              name="journal_voucher_debit_or_credit"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Voucher Debit/Credit </option>
              <option value="Debit"> Debit </option>
              <option value="Credit"> Credit </option>
            </select>
          </div>

          {/* journal_voucher_ref_type */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Ref <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_ref_type}
              name="journal_voucher_ref_type"
              className="form-select bg-light padding-pt-9"
            >
              <option value="None">None </option>
              <option value="On_Account">On Account</option>
              <option value="Advance">Advance</option>
              <option value="Against_Ref">Against Ref</option>
              <option value="New_Ref">New Ref</option>
            </select>
          </div>

          {/* journal_voucher_ref_no*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Ref No <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="journal_voucher_ref_no"
              className="form-control bg-light"
              placeholder="Enter Ref No"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_ref_no}
            />
          </div>

          {/* journal_voucher_ref_date*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Ref Date<span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="journal_voucher_ref_date"
              className="form-control bg-light"
              placeholder="Ref Date"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_ref_date}
            />
          </div>

          {/* journal_voucher_ref_amount*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Ref Amount <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="journal_voucher_ref_amount"
              className="form-control bg-light"
              placeholder="Enter Ref Amount"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_ref_amount}
            />
          </div>

          {/* journal_voucher_is_tds */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Is TDS? <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_is_tds}
              name="journal_voucher_is_tds"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Is TDS </option>
              <option value="Yes"> Yes </option>
              <option value="No"> No </option>
            </select>
          </div>

          {/* journal_voucher_is_gst */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Is GST? <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_is_gst}
              name="journal_voucher_is_gst"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Is GST </option>
              <option value="Yes"> Yes </option>
              <option value="No"> No </option>
            </select>
          </div>

          {/* journal_voucher_cost_center */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Cost Center <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={journalFormData.journal_voucher_cost_center}
              name="journal_voucher_cost_center"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Cost Center </option>
              <option value="journal_voucher_cost_center">
                {" "}
                journal_voucher_cost_center{" "}
              </option>
            </select>
          </div>

          {/* journal_voucher_address*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Address <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="journal_voucher_address"
              className="form-control bg-light"
              placeholder="Enter Address"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_address}
            />
          </div>

          {/* journal_voucher_narration*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Narration <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="journal_voucher_narration"
              className="form-control bg-light"
              placeholder="Enter Narration"
              onChange={onValueChange}
              value={journalFormData.journal_voucher_narration}
            />
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="d-flex gap-2 mt-3">
          <button
            onClick={() => throttledSubmit()}
            // onClick={() => submitJournalForm()}
            className="btn btn-primary px-4"
          >
            <i className="fas fa-save me-1"></i> Save
          </button>
        </div>

        <hr />

        {spinnerLoader ? (
          <>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "400px", width: "100%" }}
            >
              <BeatLoader />
            </div>
          </>
        ) : (
          <>
            <div className="table-responsive custom-table">
              <Table
                className="table datanew dataTable no-footer"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </div>

            <AccountPagination
              currentPage={currentPage}
              totalPages={totalPage}
              onPageChange={(page) => {
                getAllVoucherData(page);
              }}
            />
          </>
        )}
      </div>
    </>
  );
};

export default VoucherProcessingJournalVoucher;
